import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const Header = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) {
        console.error('Error signing out:', error.message);
        toast({
          variant: "destructive",
          title: "Error",
          description: "Failed to sign out. Please try again.",
        });
        return;
      }
      toast({
        title: "Signed out successfully",
      });
      navigate("/login");
    } catch (err) {
      console.error('Unexpected error during sign out:', err);
      toast({
        variant: "destructive",
        title: "Error",
        description: "An unexpected error occurred. Please try again.",
      });
    }
  };

  return (
    <header className="border-b bg-white">
      <div className="flex h-16 items-center justify-between px-4 md:px-8">
        <div className="flex items-center gap-6">
          <img 
            src="https://dwam-ip.netlify.app/dwam_logo.svg" 
            alt="DWAM Logo" 
            className="h-8"
          />
          <nav className="hidden md:flex items-center gap-6">
            <Button 
              variant="ghost" 
              onClick={() => navigate("/dashboard")}
            >
              Leads
            </Button>
            <Button 
              variant="ghost" 
              onClick={() => navigate("/jobs")}
            >
              Jobs
            </Button>
            <Button 
              variant="ghost" 
              onClick={() => navigate("/ccpa")}
            >
              CCPA Requests
            </Button>
          </nav>
        </div>
        <Button 
          variant="outline" 
          onClick={handleSignOut}
        >
          Sign Out
        </Button>
      </div>
    </header>
  );
};